import React from "react";
import PropTypes from "prop-types";

import ReactWordcloud from "react-wordcloud";

const options = {
  colors: ["#063A93", "#0B6DC2"],
  enableTooltip: false,
  deterministic: true,
  randomSeed: "random",
  fontFamily: "Atlas Grotesk",
  padding: 4,
  fontSizes: [16, 24],
  // rotations: 2,
  rotations: 1,
  spiral: "archimedean",
  rotationAngles: [0, 90, 270],
  transitionDuration: 0
};

const fullReportOptions = {
  ...options,
  padding: 16,
  fontSizes: [24, 48]
};

/* eslint-disable react/require-default-props */
const WordCloud = ({ words, type, ...rest }) => {
  let wordCloudOptions = type === "fullReport" ? fullReportOptions : options;
  if (rest) wordCloudOptions = { ...wordCloudOptions, ...rest };

  const memoizedWords = React.useMemo(() => words, [words]);
  return (
    <ReactWordcloud options={{ ...wordCloudOptions }} words={memoizedWords} />
  );
};

WordCloud.propTypes = {
  words: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  type: PropTypes.string
};

export default WordCloud;
